import FuseAuthorization from '@fuse/core/FuseAuthorization';
import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import FuseTheme from '@fuse/core/FuseTheme';
import { GlobalComponents } from 'app/store/globalcontext';
import React from 'react';
import FuseLayouts from './fuse-layouts/FuseLayouts';
import { SessaoBloqueada } from './main/login';

const RenderTheme = ({ theme = '' }) => {
  let layout;

  const isRotaPublica = window.location.href.indexOf('/public/') > -1;

  if (isRotaPublica || theme === 'FINANCEIRO') {
    layout = <FuseLayouts.LayoutFinanceiro />;
  } else if (theme === 'SESSAO_BLOQUEADA') {
    layout = <SessaoBloqueada />;
  } else if (theme === 'ONBOARDING') {
    layout = <FuseLayouts.LayoutOnboarding />;
  } else {
    layout = <FuseSplashScreen />;
  }

  return (
    <>
      <FuseAuthorization>
        <FuseTheme>
          <GlobalComponents />
          {layout}
        </FuseTheme>
      </FuseAuthorization>
    </>
  );
};

export default RenderTheme;
